type Listener = (key: string) => void;

const listeners = new Set<Listener>();

/** Calls `listener` with the key of every cache item that is written. Returns the unsubscribe function. */
export const onCacheChange = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyCacheChange = (key: string): void => {
  for (const listener of [...listeners]) {
    listener(key);
  }
};
